import SCSS from '../../styles/settings/animation.scss';

const animGetTime = (declValue: string) => {
  if (declValue.endsWith('ms')) {
    return parseFloat(declValue);
  } else if (declValue.endsWith('s')) {
    return parseFloat(declValue) * 1000;
  }
  return 200;
};

export const ANIMATION_SETTINGS: {
  easeIn: string;
  easeInOut: string;
  easeOut: string;

  timeDefault: string;
  med: string;
  short: string;
  slow: string;

  durationDefault: number;
  durationMedium: number;
  durationShort: number;
  durationSlow: number;
} = {
  ...SCSS,
  durationDefault: animGetTime(SCSS.timeDefault),
  durationMedium: animGetTime(SCSS.med),
  durationShort: animGetTime(SCSS.short),
  durationSlow: animGetTime(SCSS.slow),
};
